export var StripeAccountStatus;
(function (StripeAccountStatus) {
    /**
     * Account exists on Stripe and charges are enabled
     */
    StripeAccountStatus["REGISTERED"] = "REGISTERED";
    /**
     * Account doesn't exist on Stripe
     */
    StripeAccountStatus["UNREGISTERED"] = "UNREGISTERED";
    /**
     * Account exists on Stripe and charges are *NOT* enabled
     */
    StripeAccountStatus["INCOMPLETE"] = "INCOMPLETE";
})(StripeAccountStatus || (StripeAccountStatus = {}));
//# sourceMappingURL=stripe-account-status.enum.js.map